import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, EMPTY } from "rxjs";
import { switchMap, map, take } from "rxjs/operators";
import { AzureToken } from "../interfaces/token.interface";
import { GetHttpHeaders } from "./serviceUtils";
import { GetTokenService } from "./getToken.service";
import { appLocalEnviroment } from "../../../environments/environment";

@Injectable({
    providedIn: "root"
})
export class RequestUtilsService {
    constructor(
        private http: HttpClient,
        private getTokenService: GetTokenService
    ) {}

    private getToken(): Observable<AzureToken | null> {
        return this.getTokenService.token$;
    }

    createGetRequest<T>(url: string, mapFn: (response: any) => T, headersFn: (token: AzureToken) => HttpHeaders = GetHttpHeaders): Observable<T> {
        return this.getToken().pipe(
            switchMap((token: AzureToken | null) => {
                if (token) {
                    const headers = headersFn(token);
                    return this.http.get<T>(`${appLocalEnviroment.apiUrl}${url}`, { headers }).pipe(map(mapFn));
                }
                return EMPTY;
            })
        );
    }

    createPatchRequest<T>(
        url: string,
        body: { [key: string]: any },
        mapFn: (response: any) => T,
        headersFn: (token: AzureToken) => HttpHeaders = GetHttpHeaders
    ): Observable<T> {
        return this.getToken().pipe(
            switchMap((token: AzureToken | null) => {
                if (token) {
                    const headers = headersFn(token);
                    return this.http.patch<T>(`${appLocalEnviroment.apiUrl}${url}`, body, { headers }).pipe(map(mapFn));
                }
                return EMPTY;
            })
        );
    }

    createPostRequest<T>(
        url: string,
        body: { [key: string]: any },
        mapFn: (response: any) => T,
        headersFn: (token: AzureToken) => HttpHeaders = GetHttpHeaders
    ): Observable<T> {
        return this.getToken().pipe(
            take(1),
            switchMap((token: AzureToken | null) => {
                if (token) {
                    const headers = headersFn(token);
                    return this.http.post<T>(`${appLocalEnviroment.apiUrl}${url}`, body, { headers }).pipe(map(mapFn));
                }
                return EMPTY;
            })
        );
    }

    createDeleteRequest<T>(url: string, mapFn: (response: any) => T, headersFn: (token: AzureToken) => HttpHeaders = GetHttpHeaders): Observable<T> {
        return this.getToken().pipe(
            switchMap((token: AzureToken | null) => {
                if (token) {
                    const headers = headersFn(token);
                    return this.http.delete<T>(`${appLocalEnviroment.apiUrl}${url}`, { headers }).pipe(map(mapFn));
                }
                return EMPTY;
            })
        );
    }
}
